// Plugins with activation 'idle' do not start at boot: the kernel starts them one by one when the browser has a
// free moment (whiteboard G4, S19: ~95 plugins loading at once after a reload held a visit's card 2.5 s). The
// first key or pointer press starts the rest without waiting, so a person never waits for a sleeping plugin.
export const IDLE_TIMEOUT_MS = 4000

// Idle plugins woken per free moment: 16 start in two rounds (one at a time took minutes on a busy board, whiteboard G4 S20).
export const IDLE_BATCH = 8

// 'idle' or 'timeout' at the browser's next free moment, at the latest after timeoutMs; 'idle' at once where
// there is no requestIdleCallback (node tests).
export function whenIdle(timeoutMs = IDLE_TIMEOUT_MS) {
  if (typeof requestIdleCallback !== 'function') return Promise.resolve('idle')
  return new Promise((resolve) =>
    requestIdleCallback((deadline) => resolve(deadline.didTimeout ? 'timeout' : 'idle'), { timeout: timeoutMs })
  )
}

// 'input' on the first pointerdown or keydown. Where there is no window it never settles; it is only raced.
export function firstInput(target = globalThis.window) {
  return new Promise((resolve) => {
    if (!target?.addEventListener) return
    const done = () => {
      target.removeEventListener('pointerdown', done, true)
      target.removeEventListener('keydown', done, true)
      resolve('input')
    }
    target.addEventListener('pointerdown', done, true)
    target.addEventListener('keydown', done, true)
  })
}
